import * as React from "react";
import Paper from "@mui/material/Paper";
import Table from "@mui/material/Table";
import TableBody from "@mui/material/TableBody";
import TableCell from "@mui/material/TableCell";
import TableContainer from "@mui/material/TableContainer";
import TableHead from "@mui/material/TableHead";
import TablePagination from "@mui/material/TablePagination";
import TableRow from "@mui/material/TableRow";
import Header from "components/Header";
import moment from "moment";
import { useTheme } from "@mui/material/styles";
import { toast } from "react-toastify";
import { Box, Grid, Dialog, DialogActionsDialog, DialogTitle, DialogActions } from "@mui/material";
import { deleteTransaction, getAllProperties, commonExpenseList } from "state/apis";
import { LocalizationProvider } from "@mui/x-date-pickers/LocalizationProvider";
import { AdapterDayjs } from "@mui/x-date-pickers/AdapterDayjs";
import { DatePicker } from "@mui/x-date-pickers/DatePicker";
import dayjs from "dayjs";
import Button from "@mui/material/Button";
import IconButton from "@mui/material/IconButton";
import EditIcon from "@mui/icons-material/Edit";
import DefaultProperty from "components/DefaultProperty";
import { useDispatch, useSelector } from "react-redux";
import DeleteIcon from "@mui/icons-material/Delete";
import { getDefaultProperty } from "state";
import CommonExpense from "./CommonExpense";

const CommonExpenseHistory = () => {
    const theme = useTheme();
    const [isLoading, setIsLoading] = React.useState(true);
    const [data, setData] = React.useState([]);
    const [selectedRow, setSelectedRow] = React.useState(null);
    const [openAddForm, setOpenAddForm] = React.useState(false);
    const [property, setProperty] = React.useState([]);
    const [totalData, setTotalData] = React.useState([]);
    const [page, setPage] = React.useState(0);
    const [rowsPerPage, setRowsPerPage] = React.useState(50);
    const propertyId = useSelector((state) => state.global.defaultProperty);
    const [deleteConfirmationOpen, setDeleteConfirmationOpen] = React.useState(false);
    const [deleteItem, setDeleteItem] = React.useState(null);
    const [date, setDate] = React.useState({
        from: "",
        to: "",
    });
    const dispatch = useDispatch();
    const [role, setRole] = React.useState({});
    const [isSoldProperty, setIsSoldProperty] = React.useState(false);

    React.useEffect(() => {
        fetchData();
        // fetchProperty();
        fetchRole();
    }, [page, rowsPerPage, date.from, date.to]);

    const fetchRole = async () => {
        const res = await getDefaultProperty(dispatch);
        setIsSoldProperty(res?.data?.property?.isSold);
        if (res?.data?.role && res?.data?.role?.permission) {
            setRole(JSON.parse(res?.data?.role?.permission));
        }
    };
    const fetchData = async () => {
        try {
            // setIsLoading(true);
            const res = await commonExpenseList(
                rowsPerPage,
                page * rowsPerPage,
                date.from,
                date.to
            );
            setData(res?.data);
            setTotalData(res?.totalCount);
            setIsLoading(false);
        } catch (error) {
            console.error("Error fetching data:", error);
            toast.error("Failed to fetch data. Please try again.");
        }
    };

    const handleChangePage = (event, newPage) => {
        setPage(newPage);
    };

    const handleChangeRowsPerPage = (event) => {
        setRowsPerPage(+event.target.value);
        setPage(0);
    };
    const handleFrom = (date) => {
        const data = date;
        const formattedDate = data.format("YYYY-MM-DD");

        setDate((prevData) => ({
            ...prevData,
            from: formattedDate,
        }));
    };
    const handleTo = (date) => {
        const data = date;
        const formattedDate = data.format("YYYY-MM-DD");

        setDate((prevData) => ({
            ...prevData,
            to: formattedDate,
        }));
    };

    const handleAddExpense = () => {
        setSelectedRow(null);
        setOpenAddForm(true);
    };
    const handleCloseAddForm = () => {
        setOpenAddForm(false);
    };
    const handleSubmitAddExpense = async () => {
        setOpenAddForm(false);
        setIsLoading(true);
        fetchData();
    };

    const handleEditClick = (row) => {
        setSelectedRow(row);
        setOpenAddForm(true);
    };

    const handleDeleteClick = (row) => {
        setDeleteItem(row?.id);
        setDeleteConfirmationOpen(true);
    };

    const handleDeleteConfirmation = async () => {
        try {
            await deleteTransaction(deleteItem);
            toast.success("Expense deleted successfully.");
            fetchData();
            setDeleteConfirmationOpen(false);
        } catch (error) {
            console.error("Error deleting expense:", error);
            toast.error("Failed to delete expense. Please try again.");
        }
    };

    const handleDocumentOpen = (url) => {
        window.open(url, "_blank");
    };

    if (isLoading) {
        return (
            <Box sx={{ p: "24px 28px" }}>
                <Header title="Common Expenses" />
                <Box sx={{ mt: 4, textAlign: "center", color: "#5a6a85" }}>Loading...</Box>
            </Box>
        );
    }

    return (
        <Box sx={{ p: "24px 28px" }}>
            <Header title="Common Expenses" subtitle="List Of Common Expenses" />
            <Paper sx={{ width: "100%", overflow: "hidden", mt: 2.5, borderRadius: "12px", boxShadow: "0 1px 3px rgba(0,0,0,0.06)" }}>
                <Box display="flex" justifyContent="flex-end" p={2}>
                    <Grid container spacing={1} p={"5px"} alignItems="center">
                        <Grid item xs={2}>
                            <LocalizationProvider dateAdapter={AdapterDayjs}>
                                <DatePicker
                                    label="From"
                                    name="contractFrom"
                                    onChange={handleFrom}
                                    value={date.from ? dayjs(date.from) : null}
                                    format="DD/MM/YYYY"
                                    sx={{
                                        width: "100%",
                                        "& .MuiOutlinedInput-root": {
                                            "&.Mui-focused fieldset": {
                                                borderColor: "primary.main",
                                            },
                                        },
                                        "& .MuiInputLabel-root": {
                                            "&.Mui-focused": {
                                                color: "primary.main",
                                            },
                                        },
                                    }}
                                />
                            </LocalizationProvider>
                        </Grid>
                        <Grid item xs={2}>
                            <LocalizationProvider dateAdapter={AdapterDayjs}>
                                <DatePicker
                                    label="To"
                                    name="contractTo"
                                    onChange={handleTo}
                                    value={date.to ? dayjs(date.to) : null}
                                    format="DD/MM/YYYY"
                                    sx={{
                                        width: "100%",
                                        "& .MuiOutlinedInput-root": {
                                            "&.Mui-focused fieldset": {
                                                borderColor: "primary.main",
                                            },
                                        },
                                        "& .MuiInputLabel-root": {
                                            "&.Mui-focused": {
                                                color: "primary.main",
                                            },
                                        },
                                    }}
                                />
                            </LocalizationProvider>
                        </Grid>
                        <Grid item xs={8} container justifyContent="flex-end">
                            {role?.commonExpense?.add && !isSoldProperty && (
                                <Button
                                    variant="contained"
                                    color="primary"
                                    onClick={handleAddExpense}
                                >
                                    Add Common Expense
                                </Button>
                            )}
                        </Grid>
                    </Grid>
                </Box>
                <TableContainer
                    sx={{ maxHeight: 900 }}
                >
                    <Table stickyHeader size="small">
                        <TableHead>
                            <TableRow>
                                <TableCell>S. No</TableCell>
                                <TableCell>Date</TableCell>
                                <TableCell>Bill</TableCell>
                                <TableCell>Type</TableCell>
                                <TableCell>Description</TableCell>
                                <TableCell>Amount</TableCell>
                                <TableCell>Remark</TableCell>
                                <TableCell>Attachment</TableCell>
                                {(role?.commonExpense?.delete || role?.commonExpense?.update) &&
                                    !isSoldProperty && (
                                        <TableCell>Actions</TableCell>
                                    )}
                            </TableRow>
                        </TableHead>
                        <TableBody>
                            {data.map((row, index) => (
                                <TableRow hover role="checkbox" tabIndex={-1} key={row?.id}>
                                    <TableCell>{index + 1}</TableCell>
                                    <TableCell>
                                        {row?.date ? moment(row?.date).format("DD/MM/YYYY") : "-"}
                                    </TableCell>
                                    <TableCell>{row?.billNumber}</TableCell>
                                    <TableCell>{row?.expense_type?.name}</TableCell>
                                    <TableCell>
                                        {row?.description !== null ? row?.description : "-"}
                                    </TableCell>
                                    <TableCell>{Number(row?.amount).toFixed(2)}</TableCell>
                                    <TableCell>
                                        {row?.remarks !== null ? row?.remarks : "-"}
                                    </TableCell>
                                    <TableCell
                                        style={{
                                            cursor: row?.attachment ? "pointer" : "default",
                                        }}
                                    >
                                        {row?.attachment && (
                                            <Button
                                                onClick={() => {
                                                    if (row?.attachment) {
                                                        handleDocumentOpen(row?.attachment);
                                                    }
                                                }}
                                                variant="contained"
                                                color="primary"
                                            >
                                                View
                                            </Button>
                                        )}
                                    </TableCell>
                                    {(role?.commonExpense?.delete || role?.commonExpense?.update) &&
                                        !isSoldProperty && (
                                            <TableCell>
                                                {role?.commonExpense?.update && (
                                                    <IconButton
                                                        onClick={() => handleEditClick(row)}
                                                    >
                                                        <EditIcon />
                                                    </IconButton>
                                                )}
                                                {role?.commonExpense?.delete && (
                                                    <IconButton
                                                        color="error"
                                                        onClick={() => handleDeleteClick(row)}
                                                    >
                                                        <DeleteIcon />
                                                    </IconButton>
                                                )}
                                            </TableCell>
                                        )}
                                </TableRow>
                            ))}
                        </TableBody>
                    </Table>
                </TableContainer>
                <TablePagination
                    rowsPerPageOptions={[10, 25, 50, 100]}
                    component="div"
                    count={totalData}
                    rowsPerPage={rowsPerPage}
                    page={page}
                    onPageChange={handleChangePage}
                    onRowsPerPageChange={handleChangeRowsPerPage}
                />
                <CommonExpense
                    open={openAddForm}
                    onClose={handleCloseAddForm}
                    onSubmit={handleSubmitAddExpense}
                    editData={selectedRow}
                    editMode={!!selectedRow}
                    property={property}
                />
                <Dialog
                    open={deleteConfirmationOpen}
                    onClose={() => setDeleteConfirmationOpen(false)}
                >
                    <DialogTitle fontWeight={"bold"}>Are you sure you want to delete?</DialogTitle>
                    <DialogActions>
                        <Button
                            onClick={() => setDeleteConfirmationOpen(false)}
                            sx={{ color: "#5a6a85" }}
                        >
                            Cancel
                        </Button>
                        <Button onClick={handleDeleteConfirmation} color="error" autoFocus>
                            Delete
                        </Button>
                    </DialogActions>
                </Dialog>
            </Paper>
        </Box>
    );
};

export default CommonExpenseHistory;
